/**
 * Text utility functions for AI Prescription
 */

/**
 * Capitalizes the first letter of a text string
 * @param text - The text to capitalize
 * @returns The text with first letter capitalized, or original text if empty
 */
export const capitalizeFirstLetter = (text: string): string => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/**
 * Sanitizes a value by handling null, undefined, and string representations of null
 * @param value - The value to sanitize
 * @returns An empty string if value is null/undefined, otherwise trimmed string
 */
export const sanitizeValue = (value: any): string => {
  if (!value || value === "null" || value === "undefined" || value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

/**
 * Replaces "dosage" with "dose" in text (case-insensitive)
 * @param text - The text to process
 * @returns The text with "dosage" replaced by "dose", or empty string if invalid
 */
export const replaceDosageWithDose = (text: string): string => {
  if (!text || typeof text !== 'string') return text || "";
  return text.replace(/dosage/gi, "dose");
};

